import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import _ from 'underscore';
import { Link, Grid, Tooltip, IconButton, Card, CardContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FilesDropzone } from 'components';
import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';
import FilesDataTable from './components/FilesDataTable';
import { AddAttachedFile, DeleteAttachFile } from '../../../../actions/TicketsActions';

const useStyles = makeStyles((theme) => ({
	root: {},
	deleteButton: {
		color: theme.palette.error.main
	}
}));

const Files = (props) => {
	const { files } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector((state) => state.session.user);
	const ticket = useSelector((state) => state.ticketsReducer.ticket);
	const _upload = (file) => {
		if (file[0].size > 200000000) {
			dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 200MB', options: { variant: 'warning' } }));
			return;
		}

		UploadFile(file[0]).then(response => {
			dispatch(AddAttachedFile(ticket.details.id, response.data, user.id));
		});
	};

	const _deleteFile = (fileId) => {
		dispatch(DeleteAttachFile(ticket.details.id, fileId, user.id));
	};

	const _downloadFile = (fileName) => {
		dispatch(DownloadFile(`${ticket.details.defaultAttachFolder}\\${fileName}`));
	};

	return (
		<Grid container spacing={3}>
			<Grid item lg={12} xs={12}>
				<Card className={classes.container}>
					<CardContent>
						<FilesDropzone multiple={false} upload={_upload} />
					</CardContent>
				</Card>
			</Grid>
			<Grid item lg={12} xs={12}>
				<FilesDataTable files={files} DownloadFile={_downloadFile} DeleteFile={_deleteFile} userId={user.id} />
			</Grid>
		</Grid>

	);
};

Files.propTypes = {
	files: PropTypes.array.isRequired
};

export default Files;
